import React from "react";
import styles from "./LabeledControlGroup.module.css";

const LabeledControlGroup = ({
  label,
  children,
  validationError,
  style,
  required = false,
  disabled = false,
  ...rest
}) => {
  return (
    <div className={styles.root}>
      <div
        className={`${styles.labeledControlGroup} ${
          validationError ? styles.error : ""
        }`}
        style={style}
        {...rest}
      >
        <h3 className={styles.groupLabel}>
          {label} {required && <span className={styles.required}>*</span>}
        </h3>
        {children}
      </div>
      <p className={styles.validationError}>{validationError}</p>
    </div>
  );
};

export { LabeledControlGroup };
